import axios from '../axios/axios';
import {
  BUSINESS_INSURANCE_DATA_REQUEST,
  BUSINESS_INSURANCE_DATA_SUCCESS,
  BUSINESS_INSURANCE_DATA_FAIL,
} from '../constants/businessInsuranceConstants';

export const businessInsuranceAction = () => async (dispatch) => {
  try {
    dispatch({ type: BUSINESS_INSURANCE_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s22',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: BUSINESS_INSURANCE_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }
    dispatch({
      type: BUSINESS_INSURANCE_DATA_FAIL,
      payload: error,
    });
  }
};
